import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogAlertComponent } from '../sharedch/dialog-alert/dialog-alert.component';

@Injectable({
  providedIn: 'root'
})
export class DialogAlertService {

  constructor(private dialog: MatDialog) { }

  openAlertDialog(msg: string, documentType:string, msg2:string) {
    return this.dialog.open(DialogAlertComponent, {
      width: '390px',
      panelClass: 'alert-dialog-container',
      disableClose: true,
      data: {
        message: msg +" "+documentType+" "+msg2,
        // documentType:documentType,
        // message2:msg2
      }
    });
  }
}
